import TermsBuyNowPayLater from './BuyNowPayLater';
import TermsStandard from './Standard';
import useTerms from './useTerms';

const Terms: React.FunctionComponent = function () {
  const { apr, aprType, termRef } = useTerms();
  if (!apr || !aprType) return null;
  return (
    <>
      <div className="mt-8" ref={termRef} />
      {aprType === 'BUYNOW_PAYLATER' ? (
        <TermsBuyNowPayLater />
      ) : (
        <TermsStandard />
      )}
    </>
  );
};

export default Terms;
